import React from 'react';
import { Link } from 'react-router-dom';

import portfolioData from '../Portfolio/portfolioData.json';
import './Home.css';

function Home() {
    const featuredProjects = portfolioData.filter((project) => project.featured).slice(0, 4);
    const getProjectPath = (project) => project.caseStudyPath || `/portfolio/${project.id}`;

    return (
        <div id="home-container" className="container-fluid">
            <div className="row home-hero">
                <div className="col col-4 col-expand text-center" style={{alignItems: "center"}}>
                    <div className="img-responsive h-100 bottom-align home-image">
                        <img src={'/assets/imgs/bg.png'} alt="Me in black and white" />
                    </div>
                </div>
                <div className="col col-8 col-expand text-light h-100 home-content home-panel">
                    <p className="home-kicker">Software developer in Toronto</p>
                    <h1 className="display-4 text-bold">I design and build polished web, mobile, and product experiences.</h1>
                    <p className="lead">
                        I build secure, reliable software across authentication, backend services, APIs, mobile apps, and customer-facing product experiences.
                    </p>
                    <div className="home-actions">
                        <Link to="/portfolio" className="btn btn-indigo">View Portfolio</Link>
                        <Link to="/services" className="btn btn-light">Services & Quotes</Link>
                    </div>
                    <div className="proof-list" aria-label="Portfolio highlights">
                        <div className="proof-item">
                            <strong>Full-stack delivery</strong>
                            <span>UX, frontend, backend, integrations, launch, and support.</span>
                        </div>
                        <div className="proof-item">
                            <strong>Enterprise experience</strong>
                            <span>Authentication and login systems work at Okta/Auth0.</span>
                        </div>
                        <div className="proof-item">
                            <strong>Product mindset</strong>
                            <span>Dashboards, payments, apps, websites, and operational tooling.</span>
                        </div>
                    </div>
                    <p className="home-secondary-link">
                        Off-screen I also do portrait photography. <a href="https://photobyr.id" target="_blank" rel="noreferrer">View photography work</a>.
                    </p>
                </div>
            </div>
            <section className="home-featured-section" aria-labelledby="home-featured-heading">
                <div className="home-featured-inner">
                    <div className="home-featured-heading">
                        <p className="eyebrow">Featured work</p>
                        <h2 id="home-featured-heading" className="display-6 text-indigo">Projects with product depth</h2>
                        <p>
                            A closer look at product platforms, open-source tools, admin workflows, and web experiences I have designed or built.
                        </p>
                    </div>
                    <div className="home-featured-grid">
                        {featuredProjects.map((project) => (
                            <Link className="home-featured-card" to={getProjectPath(project)} key={project.id}>
                                <img src={`/assets/imgs/portfolio/${project.img}`} alt={`${project.name} preview`} />
                                <span>{project.name}</span>
                                <small>{project.description}</small>
                            </Link>
                        ))}
                    </div>
                    <Link className="btn btn-indigo" to="/portfolio">View Portfolio</Link>
                </div>
            </section>
        </div>
    )
}

export default Home
